import { z } from 'zod'
import { workspaceSchema } from '../workspace-schema'

/** Set by the platform on every reply the bridge produced; absent on the platform's own refusals. */
export const WORKSPACE_RESPONSE_HEADER = 'X-Workspace-Response'

export type { WorkspaceOperation } from './agent-contract'

/** The platform's workspace row as `GET /v2/hermes` reports it on the relay path, which names its backend. */
export const relayWorkspaceSchema = workspaceSchema.extend({ backend: z.string() })

/** What `/api/workspace` tells the browser: the platform row, nothing else. */
export const workspaceState = z
  .object({
    workspace_id: z.uuid(),
    backend: z.string(),
    status: z.enum(['provisioning', 'ready', 'failed', 'resetting', 'stopping', 'stopped', 'suspended']),
    connected: z.boolean(),
    can_stop: z.boolean(),
    can_reset: z.boolean(),
    detail: z.string(),
  })
  .strict()
export type WorkspaceState = z.infer<typeof workspaceState>

/** The platform's refusals from `POST /v2/workspaces/{id}/ops`. They never carry the bridge header. */
export const platformRefusal = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('unknown_workspace') }),
  z.object({ kind: z.literal('workspace_retired') }),
  z.object({ kind: z.literal('legacy_backend') }),
  z.object({ kind: z.literal('waking'), retry_after_ms: z.number().int().nonnegative() }),
  z.object({ kind: z.literal('paused'), detail: z.string() }),
  z.object({ kind: z.literal('starting'), detail: z.string() }),
  z.object({ kind: z.literal('unavailable'), reason: z.enum(['connection_unavailable', 'capacity', 'transport']) }),
  z.object({ kind: z.literal('too_large'), limit_bytes: z.number().int().positive() }),
])
export type PlatformRefusal = z.infer<typeof platformRefusal>

/** A stream that lost its bridge ends with one in-band `relay_error` event carrying this body. */
export const relayStreamError = z.object({ kind: z.literal('unavailable'), reason: z.literal('transport') })
